import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { focusStyle } from '../styles/mixins';
import { hexToRgbA, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => {

  return createStyles({
  root: {
    padding: 0,
    marginRight: 8,
    '&.MuiRadio-root': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&.Mui-checked:hover': {
        backgroundColor: 'transparent',
      },
      '&$error': {
        '& circle:first-child': {
          stroke: theme.color.reds[100],
          strokeWidth: 2,
        },
        '& $radioIconCheck': {
          '& circle:last-child': {
            fill: theme.color.reds[100],
          },
        },
      },
    },
    [theme.breakpoints.down('xs')]: {
      marginRight: 12,
    },
    '& svg': {
      height: 24,
      width: 24,
      overflow: 'visible',
      '& circle:first-child': {
        fill: theme.color.greys[0],
        stroke: theme.color.greys[40],
        strokeWidth: 2,
      },
      '& circle:last-child': {
        fill: 'transparent',
      },
    },
    '& $radioIconCheck': {
      '& circle:first-child': {
        stroke: theme.color.oranges[50],
        strokeWidth: 2,
      },
      '& circle:last-child': {
        fill: theme.color.oranges[50],
      },
    },
    '&.Mui-focusVisible': {
      ...focusStyle(theme),
    },
    '&:hover': {
      '& circle:first-child': {
        stroke: theme.color.greys[40],
      },
      '& circle:last-child': {
        fill: theme.color.greys[0],
      },
    },
    '&.Mui-disabled': {
      '& $radioIcon': {
        '& circle': {
          fill: 'transparent',
        },
        '& circle:first-child': {
          stroke: hexToRgbA(theme.color.greys[40], 0.4),
        },
      },
      '& $radioIconCheck': {
        '& circle:first-child': {
          stroke: hexToRgbA(theme.color.oranges[50], 0.4),
        },
        '& circle:last-child': {
          fill: hexToRgbA(theme.color.oranges[50], 0.4),
        },
      },
    },

  },
  radioIcon: {},
  radioIconCheck: {},
  error: {}
}); }, { name: 'Radio', index: StylesIndexInjections.UI_ATOMS });
